'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { DEFAULT_SIDEBAR, SidebarContext, SidebarInstanceContext } from '../context';
import type { SidebarToken } from '../context';
function useSidebar(target) {
  const $ = _c(4);
  const context = React.useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider.");
  }
  const enclosingSidebar = React.useContext(SidebarInstanceContext);
  let t0;
  if ($[0] !== context || $[1] !== enclosingSidebar || $[2] !== target) {
    t0 = context.getSidebarState(target ?? enclosingSidebar ?? DEFAULT_SIDEBAR);
    $[0] = context;
    $[1] = enclosingSidebar;
    $[2] = target;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}
export { useSidebar };